/** @module Quality/NewTestRun */
define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi",
	"csi/comm/PostRequest",
	"csi/table/New",
	"csi/xml",
	"Apparel/DesignatedSupplierMixin",
	"Apparel/ProductType",
	"./TestRunActionMixin",
	"./TestRunForm"
], function(array, declare, csi, PostRequest, New, xml, DesignatedSupplierMixin, ProductType, TestRunActionMixin, TestRunForm) {

	return declare([New, DesignatedSupplierMixin, TestRunActionMixin], {

		/**
		 * @override
		 * Customize Test Run form
		 */
		onCreatePopupDefView: function(defView) {

			var parent = this.getParent();
			var fColor = defView.getField("TestRunColor");
			var fSample = defView.getField("TestRunSample");

			if (parent.$Type == "QualityAdmin") {
				// New Template
				if (fColor) {
					fColor.bHidden = true;
				}
				if (fSample) {
					fSample.bHidden = true;
				}

			} else if ((parent.$Type == "Material" || parent.$Type == "Style") && !ProductType.hasColor(parent)) {
				if (fColor) {
					fColor.bHidden = true;
				}
			}

			// add controller class for form to manage action
			defView.classController = TestRunForm;
		},

		/**
		 * @override
		 * initialize designated supplier on Test Run form
		 */
		onCreatePopup: function(view) {
			this.initializeDPS(view, "TestRunSupplier");
			var parent = this.getParent();
			if (parent.$Type === "Sample" || parent.$Type === "MaterialSample") {
				view.addFixedValue("TestRunSample", this.m_urlParent);
			}
		},

		/**
		 * @override
		 * Retrieves the params for the current view - by default, gets the parent of the current object,
		 * sets flag to create multiple test runs
		 */
		onCreatePopupParams: function(params) {
			if (!this.relation || this.relation.getId() != "Templates") {
				this.getTestRunFormParams(params);
			}
		},

		/**
		 * Retrieves the params for the current TestRun view - by default,
		 * sets parameters for Product and sets flag to create multiple test runs
		 * @param {Object} params - object to set params for TestRun view
		 */
		getTestRunFormParams: function(params) {
			params = params || {};
			params.testRunContextNode = this.getParent();
			params.bCanCreateMultipleTestRuns = true;
		},

		/**
		 * @override
		 * Retrieve return node request - adds new URLs to request
		 */
		getReturnNodeRequest: function(urlsNew) {
			if (this.popupView.bCanCreateMultipleTestRuns && this.popupView.newTestRuns) {
				urlsNew = urlsNew.concat(this.popupView.newTestRuns);
			}
			return this.inherited(arguments, [urlsNew]);
		},

		/**
		 * @override
		 * Retrieve the new Test Run nodes
		 */
		getNewNodes: function() {
			if (this.popupView.bCanCreateMultipleTestRuns) {
				return this.m_cache.getNodes(this.popupView.newTestRuns);
			}
			return this.inherited(arguments);
		},

		/**
		 * @override
		 * create Test runs according to form and add to source
		 */
		toWriter: function() {
			if (this.popupView.bCanCreateMultipleTestRuns) {
				this.bValidate = false;
				this.bUpdateParent = false;
				return this.popupView.toWriterTestRuns(this);
			}
			return this.inherited(arguments);
		},

		/**
		 * @override
		 * Add the testSpecs attribute
		 * @param {CallMethod} call
		 */
		_writeRequestParameters: function(call) {
			this.inherited(arguments);
			var testSpecsFieldValue = this.m_formData.getFieldValue("TestSpecs", true);
			var groupSpecsFieldValue = this.m_formData.getFieldValue("GroupSpecs", true);
			if (testSpecsFieldValue && testSpecsFieldValue.length != 0) {
				call.addParameter("AddURLs", xml.ATTR_REFLIST, testSpecsFieldValue);
			} else {
				call.addParameter("AddURLs", xml.ATTR_REFLIST, groupSpecsFieldValue);
			}
		},

		/**
		 * @override
		 * Do not allow Save & Go since you can (apparently) always create multiple test runs (bCanCreateMultipleTestRuns)
		 */
		_canNavigate: function() {
			return false;
		}
	});
});